import React, { Component } from "react"
import { Input, Table, message } from "antd"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import { observer, inject } from "mobx-react"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
    }
  }

  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  showEditModal = (record) => {
    this.setState({
      showEditModal: true,
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  handleEdit = (id) => {
    const { getOrgDetail } = this.props.store
    getOrgDetail(id).then(
      res => {
        this.setState({
          showEditModal: true,
        })
      }
    )

  }

  render() {
    const { detailData, setDetailData, updateOrg } = this.props.store

    const {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      },
    } = this.props

    const columns = [
      {
        width: "10%",
        title: (<div className="ta-c">机构名称</div>),
        className: "ta-c",
        dataIndex: "name",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        width: "8%",
        title: (<div className="ta-c">联系电话</div>),
        className: "ta-c",
        dataIndex: "tel",
        render: (text) => {
          return (
            <div>{text || '-'}</div>
          )
        }
      }, {
        width: "10%",
        title: (<div className="ta-c">地址</div>),
        className: "ta-c",
        dataIndex: "address",
        render: (text, record, index) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      }, {
        width: "10%",
        title: (<div className="ta-c">打印地址</div>),
        className: "ta-c",
        dataIndex: "printAddress",
        render: (text, record, index) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      }, {
        width: "5%",
        title: (<div className="ta-c">派驻代表</div>),
        className: "ta-c",
        dataIndex: "deputy",
        render: (text, record, index) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      }, {
        width: "5%",
        title: (<div className="ta-c">技术支持</div>),
        className: "ta-c",
        dataIndex: "support",
        render: (text, record, index) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      }, {
        width: "8%",
        title: (<div className="ta-c">创建时间</div>),
        className: "ta-c",
        dataIndex: "createTime",
        render: (text, record, index) => {
          return (
            <div>{text || "-"}</div>
          )
        }
      }, {
        width: 104,
        title: (<div className="ta-c">操作</div>),
        dataIndex: "operator",
        className: "ta-c",
        render: (text, record) => {
          return (
            <div>
              <img
                title="修改"
                src={editAbleIcon}
                alt=""
                style={{ cursor: 'pointer' }}
                onClick={() => this.handleEdit(record.id)}
              />
            </div>
          )
        }
      }
    ]

    return (
      <div className="wrapper-box">
        <Table
          columns={columns}
          className="statistics-table"
          rowKey={record => record.id}
          dataSource={tableData.slice()}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
        <MaterialModal
          title="编辑机构"
          width={450}
          className="preview-account-create-modal"
          visible={this.state.showEditModal}
          buttonText="确认提交"
          action={
            () => {
              return updateOrg()
                .then(
                  res => {
                    message.success('修改成功')
                    this.closeModal('showEditModal')
                  }
                )
            }

          }
        >
          <img
            className="pgx-modal-close"
            src={closeIcon}
            alt="关闭对话框"
            onClick={() => this.closeModal("showEditModal")}
          />
          <MaterialForm>
            <MaterialFormItem
              labelText="机构名"
              labelWidth={60}
            >
              <Input
                className="createAccount-input"
                placeholder="请输入机构名"
                value={detailData.get('name')}
                onChange={(e) => setDetailData({ name: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="联系电话"
              justify="center"
            >
              <Input
                name="tel"
                className="createAccount-input"
                placeholder="请输入联系电话"
                value={detailData.get('tel')}
                onChange={(e) => setDetailData({ tel: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="地址"
              justify="center"
            >
              <Input
                name="address"
                className="createAccount-input"
                value={detailData.get('address')}
                placeholder="请输入地址"
                onChange={(e) => setDetailData({ address: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="打印地址"
              justify="center"
            >
              <Input
                name="printAddress"
                className="createAccount-input"
                value={detailData.get('printAddress')}
                placeholder="请输入打印地址"
                onChange={(e) => setDetailData({ printAddress: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="派驻代表"
              justify="center"
            >
              <Input
                name="deputy"
                value={detailData.get('deputy')}
                className="createAccount-input"
                placeholder="请输入派驻代表"
                onChange={(e) => setDetailData({ deputy: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="技术支持"
              justify="center"
            >
              <Input
                name="support"
                value={detailData.get('support')}
                className="createAccount-input"
                placeholder="请输入技术支持"
                onChange={(e) => setDetailData({ support: e.target.value })}
              />
            </MaterialFormItem>
          </MaterialForm>
        </MaterialModal>
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/preview/organization/containers/DataTable.js